import { render } from "./Notifs.vue?vue&type=template&id=6ca01bd8"
import script from "./Notifs.vue?vue&type=script&lang=js"
export * from "./Notifs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/roms/PhpstormProjects/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__